// Our icon set: one SVG file per icon in src/assets/icons/, put into the page
// once as a hidden sprite of <symbol>s that <Icon> draws with <use>. The files'
// root paint attributes move to the .icon class, so CSS can still set the
// colour (currentColor) and the stroke width of every icon.

export const ICON_SYMBOL_PREFIX = 'i-';
export const ICON_SPRITE_ID = 'app-icon-sprite';

const ROOT_PAINT = /\s(?:fill|stroke|stroke-width|stroke-linecap|stroke-linejoin|width|height|xmlns)="[^"]*"/g;

export function iconNameOf(path: string): string {
  const file = path.slice(path.lastIndexOf('/') + 1);
  return file.replace(/\.svg$/, '');
}

export function symbolOf(name: string, svg: string): string {
  const m = svg.trim().match(/^<svg\b([^>]*)>([\s\S]*)<\/svg>$/);
  if (!m) throw new Error(`Icon ${name} is not an <svg> file`);
  const viewBox = m[1].match(/\sviewBox="([^"]+)"/)?.[1] ?? '0 0 24 24';
  const extra = m[1].replace(ROOT_PAINT, '').replace(/\sviewBox="[^"]*"/, '').trim();
  return `<symbol id="${ICON_SYMBOL_PREFIX}${name}" viewBox="${viewBox}"${extra ? ` ${extra}` : ''}>${m[2]}</symbol>`;
}

export function spriteMarkup(files: Record<string, string>): string {
  const symbols = Object.keys(files).sort().map((path) => symbolOf(iconNameOf(path), files[path])).join('');
  return `<svg xmlns="http://www.w3.org/2000/svg" id="${ICON_SPRITE_ID}" aria-hidden="true" focusable="false" style="position:absolute;width:0;height:0;overflow:hidden">${symbols}</svg>`;
}

export const ICON_FILES = import.meta.glob('../assets/icons/*.svg', { query: '?raw', import: 'default', eager: true }) as Record<string, string>;

export function installIconSprite(doc: Document = document): void {
  if (doc.getElementById(ICON_SPRITE_ID)) return;
  const holder = doc.createElement('div');
  holder.innerHTML = spriteMarkup(ICON_FILES);
  const sprite = holder.firstElementChild;
  if (sprite) doc.body.prepend(sprite);
}
